import React from 'react';
import { Link } from 'react-router-dom';
import { openNativeSettings } from '../../utils/nativeAppBridge';

function EmptyState({ isMobile, onOpenWrite }) {
  return (
    <div className="dashboard__empty">
      {/* Settings/Profile Icons */}
      <div className="dashboard__empty-icons">
        <Link 
          to="/settings"
          onClick={openNativeSettings}
          className="dashboard__icon-btn"
          aria-label="Settings"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/>
            <circle cx="12" cy="12" r="3"/>
          </svg>
        </Link>
        <Link 
          to="/profile"
          className="dashboard__icon-btn"
          aria-label="Profile"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        </Link>
      </div>

      {/* Background Orbs */}
      <div className="dashboard__empty-bg">
        <div className="dashboard__empty-orb dashboard__empty-orb--1"></div>
        <div className="dashboard__empty-orb dashboard__empty-orb--2"></div>
        <div className="dashboard__empty-orb dashboard__empty-orb--3"></div>
      </div>

      {isMobile ? (
        // Mobile Layout - Vertical Stack
        <>
          <HeroIllustration />
          <WelcomeContent onOpenWrite={onOpenWrite} />
        </>
      ) : (
        // Desktop Layout - Side by Side
        <div className="dashboard__empty-desktop-layout">
          <div className="dashboard__empty-desktop-left">
            <HeroIllustration />
          </div>
          <div className="dashboard__empty-desktop-right">
            <WelcomeContent onOpenWrite={onOpenWrite} />
          </div>
        </div>
      )}
    </div>
  );
}

function HeroIllustration() {
  return (
    <div className="dashboard__empty-hero">
      <div className="dashboard__empty-book">
        <div className="dashboard__empty-book-cover">
          <div className="dashboard__empty-book-shine"></div>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
          </svg>
        </div>
        <div className="dashboard__empty-book-pages">
          <div className="dashboard__empty-page"></div>
          <div className="dashboard__empty-page"></div>
          <div className="dashboard__empty-page"></div>
        </div>
      </div>
      
      <div className="dashboard__empty-float dashboard__empty-float--1">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      </div>
      <div className="dashboard__empty-float dashboard__empty-float--2">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
          <line x1="9" y1="9" x2="9.01" y2="9"/>
          <line x1="15" y1="9" x2="15.01" y2="9"/>
        </svg>
      </div>
      <div className="dashboard__empty-float dashboard__empty-float--3">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
      </div>
    </div>
  );
}

function WelcomeContent({ onOpenWrite }) {
  return (
    <div className="dashboard__empty-content">
      <h2 className="dashboard__empty-title">Welcome to Remori</h2>
      <p className="dashboard__empty-subtitle">Your private space for thoughts and reflections</p>
      
      <div className="dashboard__empty-features">
        <div className="dashboard__empty-feature">
          <div className="dashboard__empty-feature-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2L2 7l10 5 10-5-10-5z"/>
              <path d="M2 17l10 5 10-5M2 12l10 5 10-5"/>
            </svg>
          </div>
          <span>AI writing assistance</span>
        </div>
        <div className="dashboard__empty-feature">
          <div className="dashboard__empty-feature-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
              <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
              <line x1="12" y1="22.08" x2="12" y2="12"/>
            </svg>
          </div>
          <span>AI insights & patterns</span>
        </div>
        <div className="dashboard__empty-feature">
          <div className="dashboard__empty-feature-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 1 1 7.072 0l-5.197-5.197m0 0L7.05 7.05M13.657 13.657l-5.197-5.197m0 0L7.05 7.05"/>
            </svg>
          </div>
          <span>Smart mood analysis</span>
        </div>
      </div>
      
      <button className="dashboard__empty-cta" onClick={onOpenWrite}>
        <span className="dashboard__empty-cta-text">Begin Your First Entry</span>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="5" y1="12" x2="19" y2="12"/>
          <polyline points="12 5 19 12 12 19"/>
        </svg>
      </button>
      
      <p className="dashboard__empty-note">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
        Your entries are stored encrypted.
      </p>
    </div>
  );
}

export default EmptyState;
